import TextField, { TextFieldProps } from "@mui/material/TextField";
import React from "react";

interface CustomProductTextFieldProps {
  label?: string;
  name: string;
  value?: string | number;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur?: () => void;
  helperText?: string;
  required?: boolean;
  readOnly?: boolean;
  small?: boolean;
  error?: boolean;
  multiline?: boolean;
  rows?: number;
  fullWidth?: boolean;
  variant?: TextFieldProps["variant"];
  placeholder?: string;
  sx?: React.CSSProperties;
}
const CustomProductTextField = React.forwardRef<
  HTMLInputElement,
  CustomProductTextFieldProps
>((props, ref) => {
  const [error, setError] = React.useState(false);
  let helperText = props.helperText;

  if (helperText === "no") {
    helperText = "";
  } else if (!helperText) {
    helperText = "Please fill the field";
  }
  const value = props.value ?? "";
  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.required && e.target.value === "") {
      setError(true);
    } else {
      setError(false);
    }
  };

  return (
    <TextField
      {...props}
      value={value}
      InputLabelProps={{
        shrink: true,
      }}
      sx={{
        "& input": {
          // padding: "8.5px 14px",
          padding: "12px 14px",
          backgroundColor: "white",
        },
        // readonly
        "& input[readonly]": {
          backgroundColor: "#f5f5f5",
          cursor: "not-allowed",
        },
        width: props?.small ? "100px" : "100%",
        ...props?.sx,
      }}
      onChange={(e) => {
        props.onChange?.(e);
      }}
      inputProps={{ readOnly: props.readOnly }}
      ref={ref}
      variant="outlined"
      error={error}
      helperText={error ? helperText : ""}
      onBlur={handleOnBlur}
    />
  );
});

CustomProductTextField.displayName = "CustomProductTextField";

export default CustomProductTextField;
